// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-tabs{
  border: none !important;
}
.nav-tabs .nav-link {
  background: #ececec !important;
  margin-right: 10px;
  cursor: pointer;
  color: #9fa0b5 !important;
  padding: 0.2rem 1rem;
  border-radius: 0 !important;
}
.nav-tabs .nav-link.active{
  color: #fff !important;
  background: #4ca69a !important;
  border-color: #4ca69a !important;
}
.tab-content {
  border: 1px solid #dee2e6;
  padding: 50px 20px;
}
.tabs-no-padding .tab-content {
  padding: 0;
}
.tabs-border-top .tab-content {
  border: none;
  border-top: 1px solid #dee2e6;
}
.container {
  max-width: 100% !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/overrides/reactstrap.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;AACA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,2BAA2B;AAC7B;AACA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,gCAAgC;AAClC;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,0BAA0B;AAC5B","sourcesContent":[".nav-tabs{\n  border: none !important;\n}\n.nav-tabs .nav-link {\n  background: #ececec !important;\n  margin-right: 10px;\n  cursor: pointer;\n  color: #9fa0b5 !important;\n  padding: 0.2rem 1rem;\n  border-radius: 0 !important;\n}\n.nav-tabs .nav-link.active{\n  color: #fff !important;\n  background: #4ca69a !important;\n  border-color: #4ca69a !important;\n}\n.tab-content {\n  border: 1px solid #dee2e6;\n  padding: 50px 20px;\n}\n.tabs-no-padding .tab-content {\n  padding: 0;\n}\n.tabs-border-top .tab-content {\n  border: none;\n  border-top: 1px solid #dee2e6;\n}\n.container {\n  max-width: 100% !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
